import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import { withTranslation } from 'react-i18next';
import {
  Col,
  Row,
  Tab,
  Tabs,
} from 'react-bootstrap';
import PageWrap from '../../components/PageWrap/PageWrap';
import {
  Portlet,
  PortletBody,
  PortletCaption,
  PortletTitle,
} from '../../components/Bootstrap/Portlet';
import Settings from './Settings';
import SettingsNotifications from './SettingsNotifications';
import Map from './Map';
import {
  PlantSettings,
  PrintSettings,
  TicketSettings,
} from '../../constants/Configuration';
import { Firmware } from './Firmware';
import {
  isModuleVisible,
  Modules,
} from '../../utils/module-controller';
import { TicketNumberSettings } from './TicketNumberSettings';
import AuditLog from '../../components/AuditLog/AuditLog';

const AUDIT_LOG_SETTINGS_MODEL_NAME = 'BatchPlantSettings';

const SettingsTabs = observer((props: any) => {
  const { t } = props;
  const { settingsStore, devicesStore, dischargeStore, slumpTableStore } = useStores();
  const [ activeTab, setActiveTab ] = useState(1);
  const { plantSettings, printSettings, ticketSettings } = settingsStore;

  React.useEffect(() => {

    if (!dischargeStore.sequences.length) {
      dischargeStore.getSequences();
    }

    if (!settingsStore.configuration) {
      settingsStore.loadConfiguration();
    }

    if (!devicesStore.devices.length) {
      devicesStore.loadDevices();
    }

    if (!slumpTableStore.slumpTables.length) {
      slumpTableStore.fetchSlumpTables();
    }

  }, [devicesStore, dischargeStore, settingsStore, slumpTableStore]);

  const onTabSelect = (tab: any) => {
    setActiveTab(tab);
  };

  return (
    <PageWrap page={t('nav.Settings')}>
      <Row>
        <Col lg={7} sm={12}>
          <Portlet>
            <PortletTitle>
              <PortletCaption subject={t('nav.Settings')}/>
            </PortletTitle>
            <PortletBody>
              <Tabs defaultActiveKey={activeTab} id="mix" onSelect={onTabSelect}>
                <Tab eventKey={1} title={t('Plant')}>
                  <Settings model={PlantSettings} data={plantSettings}/>
                </Tab>
                <Tab eventKey={2} title={t('Print')}>
                  <Settings model={PrintSettings} data={printSettings}/>
                </Tab>
                <Tab eventKey={3} title={t('Notification')}>
                  <SettingsNotifications/>
                </Tab>
                <Tab eventKey={4} title={t('Local Ticket')}>
                  <TicketNumberSettings/>
                  <Settings model={TicketSettings} data={ticketSettings}/>
                </Tab>
                <Tab eventKey={5} title={t('Location')}>
                  <Map/>
                </Tab>
                {isModuleVisible(Modules.FIRMWARE) && (
                  <Tab eventKey={6} title={t('Firmware')}>
                    <Firmware/>
                  </Tab>
                )}
                <Tab eventKey={7} title={t('Audit Log')}>
                  {activeTab === 7 && (
                    <AuditLog
                      modelId={settingsStore.plantId}
                      modelName={AUDIT_LOG_SETTINGS_MODEL_NAME}
                    />
                  )}
                </Tab>
              </Tabs>

            </PortletBody>
          </Portlet>
        </Col>
      </Row>
    </PageWrap>
  );
});

export default withTranslation()(SettingsTabs);
